"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BOForm = void 0;
var core_1 = require("@material-ui/core");
var acid_components_1 = require("@michelin/acid-components");
var react_1 = __importStar(require("react"));
var react_hook_form_1 = require("react-hook-form");
var react_i18next_1 = require("react-i18next");
var FormField_1 = require("../Form/FormField");
var BOVehicleDetailsFormContext_1 = require("./BOVehicleDetailsFormContext");
var types_1 = require("./types");
var FormComponent = function (props, ref) {
    var onSubmit = props.onSubmit, onValidationFailed = props.onValidationFailed, defaultValues = props.defaultValues, readOnly = props.readOnly, mode = props.mode, onDirtyStateChanged = props.onDirtyStateChanged, optionalOption = props.optionalOption;
    var _a = BOVehicleDetailsFormContext_1.useBOVehicleDetailsFormContext(), values = _a.values, load = _a.load, loading = _a.loading;
    var t = react_i18next_1.useTranslation().t;
    var _b = react_hook_form_1.useForm({
        defaultValues: defaultValues,
        mode: 'onChange',
    }), register = _b.register, _c = _b.formState, errors = _c.errors, isDirty = _c.isDirty, handleSubmit = _b.handleSubmit, control = _b.control, reset = _b.reset, watch = _b.watch, setValue = _b.setValue;
    var tireSize = watch('tire_size_id');
    var customTireSize = watch('tire_size_id');
    var vin = watch('vin');
    if (!tireSize && customTireSize)
        setValue('tire_size_id', 'custom');
    var onValid = function (data) {
        if (!readOnly && onSubmit) {
            onSubmit(data);
        }
    };
    var onInvalid = function (err) {
        if (!readOnly && onValidationFailed) {
            onValidationFailed(err);
        }
    };
    react_1.useImperativeHandle(ref, function () { return ({
        submit: function () {
            handleSubmit(onValid, onInvalid).bind(this)();
        },
        reset: function () {
            reset();
        },
    }); });
    react_1.useEffect(function () {
        if (onDirtyStateChanged) {
            onDirtyStateChanged(isDirty);
        }
    }, [isDirty]);
    return (react_1.default.createElement(core_1.Grid, { container: true, spacing: 2 },
        react_1.default.createElement(core_1.Grid, { item: true, xs: 12 },
            react_1.default.createElement(acid_components_1.Panel, { title: t('Vehicle Information'), style: { marginBottom: 16 } },
                react_1.default.createElement(core_1.Grid, { container: true, spacing: 2 },
                    react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 6, md: 3, lg: 3 },
                        react_1.default.createElement(FormField_1.FormField, { definition: {
                                name: types_1.BOVehicleDetailsKey.year,
                                label: t('Year'),
                                options: values.years,
                                loading: loading.years,
                                helperText: t('Year is required'),
                                rules: {
                                    required: true,
                                },
                            }, error: !!errors[types_1.BOVehicleDetailsKey.year], readOnly: readOnly, register: register, control: control })),
                    react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 6, md: 3 },
                        react_1.default.createElement(FormField_1.FormField, { definition: {
                                name: types_1.BOVehicleDetailsKey.make,
                                label: t('Make'),
                                options: values.makes,
                                loading: loading.makes,
                                helperText: t('Make is required'),
                                dependencies: [types_1.BOVehicleDetailsKey.year],
                                onDependenciesChanged: load.makes,
                                rules: {
                                    required: true,
                                },
                            }, error: !!errors[types_1.BOVehicleDetailsKey.make], readOnly: readOnly, register: register, control: control })),
                    react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 6, md: 3 },
                        react_1.default.createElement(FormField_1.FormField, { definition: {
                                name: types_1.BOVehicleDetailsKey.model,
                                label: t('Model'),
                                options: values.models,
                                loading: loading.models,
                                helperText: t('Model is required'),
                                dependencies: [types_1.BOVehicleDetailsKey.year, types_1.BOVehicleDetailsKey.make],
                                onDependenciesChanged: load.models,
                                rules: {
                                    required: true,
                                },
                            }, error: !!errors[types_1.BOVehicleDetailsKey.model], readOnly: readOnly, register: register, control: control })),
                    load.options && (react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 6, md: 3 },
                        react_1.default.createElement(FormField_1.FormField, { definition: {
                                name: types_1.BOVehicleDetailsKey.option,
                                label: t('Option'),
                                options: values.options,
                                loading: loading.options,
                                helperText: !optionalOption ? t('Option is required') : '',
                                dependencies: [types_1.BOVehicleDetailsKey.year, types_1.BOVehicleDetailsKey.make, types_1.BOVehicleDetailsKey.model],
                                onDependenciesChanged: load.options,
                                rules: {
                                    required: !optionalOption,
                                },
                            }, error: !!errors[types_1.BOVehicleDetailsKey.option], readOnly: readOnly, register: register, control: control }))),
                    react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 6, md: 3, lg: 3 },
                        react_1.default.createElement(FormField_1.FormField, { definition: {
                                name: types_1.BOVehicleDetailsKey.assetType,
                                label: t('Asset Type'),
                                options: values.assetTypes,
                                loading: loading.assetTypes,
                            }, error: !!errors[types_1.BOVehicleDetailsKey.assetType], readOnly: readOnly, register: register, control: control }))))),
        react_1.default.createElement(core_1.Grid, { item: true, xs: 12 },
            react_1.default.createElement(acid_components_1.Panel, { title: t('Vehicle Details'), style: { marginBottom: 16 } },
                react_1.default.createElement(core_1.Grid, { container: true, spacing: 2 },
                    react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 4, md: 4, xl: 4 },
                        react_1.default.createElement(FormField_1.FormField, { definition: {
                                name: types_1.BOVehicleDetailsKey.vehicleUnitNumber,
                                label: t('Vehicle Unit Number'),
                                helperText: t('Vehicle Unit Number is required'),
                                rules: {
                                    required: true,
                                },
                            }, error: !!errors[types_1.BOVehicleDetailsKey.vehicleUnitNumber], readOnly: readOnly, register: register, control: control })),
                    react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 4, md: 4, xl: 4 },
                        react_1.default.createElement(FormField_1.FormField, { definition: {
                                name: types_1.BOVehicleDetailsKey.licensePlate,
                                label: t('License Plate Number'),
                                helperText: t('License Plate Number is required and should be 7 characters or shorter'),
                                rules: {
                                    required: true,
                                    maxLength: 7,
                                },
                            }, error: !!errors[types_1.BOVehicleDetailsKey.licensePlate], readOnly: readOnly, register: register, control: control })),
                    react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 4, md: 4, xl: 4, onBlur: function () { return setValue('vin', vin.toLocaleUpperCase()); } },
                        react_1.default.createElement(FormField_1.FormField, { definition: {
                                name: types_1.BOVehicleDetailsKey.vin,
                                label: t('VIN'),
                                helperText: t('VIN is required and should be 17 characters long'),
                                rules: {
                                    required: true,
                                    minLength: 17,
                                    maxLength: 17,
                                },
                                forceUppercase: true,
                            }, error: !!errors[types_1.BOVehicleDetailsKey.vin], readOnly: readOnly || mode === 'edit', register: register, control: control })),
                    react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 4, md: 4, xl: 4 },
                        react_1.default.createElement(FormField_1.FormField, { definition: {
                                name: types_1.BOVehicleDetailsKey.licenseState,
                                label: t('License Plate State'),
                                helperText: t('License Plate State is required'),
                                options: values.states,
                                loading: loading.states,
                                rules: {
                                    required: true,
                                },
                            }, error: !!errors[types_1.BOVehicleDetailsKey.licenseState], readOnly: readOnly, register: register, control: control })),
                    react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 4, md: 4, xl: 4 },
                        react_1.default.createElement(FormField_1.FormField, { definition: {
                                name: types_1.BOVehicleDetailsKey.color,
                                label: t('Color'),
                                helperText: t('Color is required'),
                                rules: {
                                    required: false,
                                },
                            }, error: !!errors[types_1.BOVehicleDetailsKey.color], readOnly: readOnly, register: register, control: control })))))));
};
var BOForm = react_1.forwardRef(FormComponent);
exports.BOForm = BOForm;
//# sourceMappingURL=Form.js.map